<template>
    <div id="app">
        <!--    <img alt="Vue logo" src="./assets/logo.png">-->
        <Summary/>
    </div>
</template>

<script>
    import Summary from "./components/Summary";

    export default {
        name: 'app',
        components: {
            Summary
        }
    }
</script>

<style>
    html{
        height: 100%;
        margin: 0;
        padding: 0;
    }
    body {
        background: #f2f2f2;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        background: #f2f2f2;
        /*margin: 20px;*/
        position: relative;
        height: 100%;
    }
</style>
